import { render } from "./inspectionServer.vue?vue&type=template&id=020e654a&scoped=true"
import script from "./inspectionServer.vue?vue&type=script&lang=js"
export * from "./inspectionServer.vue?vue&type=script&lang=js"

import "./inspectionServer.vue?vue&type=style&index=0&id=020e654a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-020e654a"

export default script